<template>
  <q-dialog v-model="downloadSchemesPage" class="share-grants-page">
    <q-card class="share-dialog">
      <q-card-section>
        <div class="text-h5">
          Downloaden geselecteerde items als een rapport
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row justify-between top-section-responsive">
          <div class="column column-width">
            <span class="input-heading">
              Rapporttitel *
            </span>
            <q-input
              class="q-mt-sm"
              outlined
              v-model="reportTitle"
              dense
              :rules="requiredFieldRule"
            />

            <span class="input-heading q-mt-md">
              Omschrijving
            </span>
            <q-input
              class="q-mt-sm"
              v-model="description"
              outlined
              type="textarea"
            />
            <!-- 
            <span class="input-heading q-mt-md">
              Naam klant
            </span>
            <q-input class="q-mt-sm" outlined v-model="customerName" dense /> -->
          </div>
        </div>
      </q-card-section>

      <q-card-section class="report-type">
        <q-select
          square
          outlined
          v-model="reportType"
          :options="options"
          label="Type rapport"
          style="width: 47%"
        />
      </q-card-section>

      <q-card-actions class="q-mt-sm" align="left">
        <q-btn
          flat
          no-caps
          label="Downloaden"
          class="submit-btn"
          color="white"
          @click="
            downloadSchemePageEmit(reportTitle, description, customerName)
          "
        />
        <q-btn
          no-caps
          flat
          label="Annuleren"
          class="cancel-btn"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from 'vue';
import store from '../../store/index';
import authHeader from '../../helpers/auth-header';
/* import MailingService from '../../services/mailing.service'; */

export default {
  setup() {
    const downloadSchemesPage = computed({
      get: () => store.state.grantItems.downloadSchemesPage,
      set: (val) => store.commit('grantItems/disableDownloadSchemesPage', val),
    });

    const grant = computed({
      get: () => store.state.grantItems.grantToShare,
    });

    const downloadSchemePageEmit = async (
      reportTitle,
      description,
      customerName
    ) => {
      if (reportTitle == '') {
        return;
      }

      const ids = store.state.grantItems.selectedResults
        .map((d) => {
          return d.schemeId;
        })
        .join(',');
      let form = document.createElement('form');
      form.method = 'post';
      form.target = '_blank';
      form.action = `./api/download/downloadSchemes`;
      form.innerHTML = `'<input type="hidden" name="jwtToken" value="${
        authHeader().Authorization
      }">
                         <input type="hidden" name="ids" value="${ids}">
                         <input type="hidden" name="reportTitle" value="${reportTitle}">
                         <input type="hidden" name="reportDescription" value="${description}">
                         <input type="hidden" name="customerName" value="${customerName}">'`;
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };

    const address = ref('');
    const message = ref('');

    const reportTitle = ref('');
    const description = ref('');
    const customerName = ref('');
    const reportTemplate = ref('');
    const templateOptions = ['Template 1', 'Template 2'];
    const searchCriteria = ref('');
    const sendWithinOrg = ref(false);

    const reportType = ref('Volledig rapport');

    return {
      options: [
        'Volledig rapport',
        /*      'Kerngegevens en samenvattingen',
        'Alleen kerngegevens', */
      ],
      reportType,
      sendWithinOrg,
      searchCriteria,
      templateOptions,
      reportTemplate,
      customerName,
      description,
      reportTitle,
      message,
      address,
      downloadSchemePageEmit,
      downloadSchemesPage,
      grant,

      requiredFieldRule: [
        (val) => (val && val.length > 0) || 'Veld is verplicht!',
      ],
      isValidEmail(val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Ongeldig e-mailadres';
      },
    };
  },
};
</script>
